import { styled } from "@mui/system";
import { Link } from "react-router-dom";


export const LinkPrimary = styled(Link)(({theme})=>({
    color: '#1976d2'
}))